import { BaseCanvas } from "@visactor/vrender-core";

import { FeishuContext2d } from "./context";

export class FeishuCanvas extends BaseCanvas {
    constructor(params) {
        super(params);
    }
    init() {
        this._context = new FeishuContext2d(this, this._dpr);
    }
    release(...params) {}
}

FeishuCanvas.env = "feishu";
//# sourceMappingURL=canvas.js.map
